import styled from "styled-components"

export const Component = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #ccc;

  &:last-child {
    border-bottom: none;
  }
`

export const GroupInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 16px;
  gap: 12px;
`

export const GroupInfoMain = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
`

export const GroupName = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black.secondary};
`

export const ViewMapLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.blue.main};

  img {
    width: 12px;
    height: 12px;
  }
`

export const GroupInfoSecondary = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`

export const GroupBasePrice = styled.div`
  font-size: 16px;
  text-align: right;

  strong {
    text-wrap-mode: nowrap;
    font-weight: 600;
  }
`
